import { LoyaltyProgramTier, OrderEntitledForCredit } from '@fiverr-private/loyalty_utils';
import {
    LoyaltyProgramTier as gqlLoyaltyProgramTier,
    OrderEntitledForCredit as gqlOrderEntitledForCredit,
} from '../../../gql-operations/gql-generated';

export const constantsToGql: Record<LoyaltyProgramTier, gqlLoyaltyProgramTier> = {
    [LoyaltyProgramTier.DIAMOND]: gqlLoyaltyProgramTier.Diamond,
    [LoyaltyProgramTier.PLATINUM]: gqlLoyaltyProgramTier.Platinum,
    [LoyaltyProgramTier.GOLD]: gqlLoyaltyProgramTier.Gold,
    [LoyaltyProgramTier.SILVER]: gqlLoyaltyProgramTier.Silver,
};

export const orderEntitledForCreditMapping: Record<OrderEntitledForCredit, gqlOrderEntitledForCredit> = {
    [OrderEntitledForCredit.EACH_PRO_SELLER]: gqlOrderEntitledForCredit.EachProSeller,
    [OrderEntitledForCredit.ALREADY_USED]: gqlOrderEntitledForCredit.AlreadyUsed,
    [OrderEntitledForCredit.EVERY_ORDER]: gqlOrderEntitledForCredit.EveryOrder,
    [OrderEntitledForCredit.FIRST_ORDER_OVER_AMOUNT]: gqlOrderEntitledForCredit.FirstOrderOverAmount,
};
